import { fetchAgg } from '@atlassian/search-client';

type ZeroQueriesParams = {
	cloudId: string;
};

type ZeroQueriesData = {
	knowledgeDiscovery?: {
		zeroQueries: {
			zeroQueries: string[];
		};
	};
};

export const fetchZeroQueries = async (variables: ZeroQueriesParams) => {
	return fetchAgg<ZeroQueriesParams, ZeroQueriesData>({
		graphQuery: ZeroQueriesQuery,
		variables,
		operationName: ZERO_QUERIES_OPERATION_NAME,
	})
		.then((response) => {
			const zeroQueries = response.data?.knowledgeDiscovery?.zeroQueries.zeroQueries || [];
			return zeroQueries.map(mapEssentialData);
		})
		.catch(() => {
			return [];
		});
};

export const mapEssentialData = (query: string) => ({
	id: query,
	title: query,
	data: query,
	type: 'zero-query' as const,
});

export const ZERO_QUERIES_OPERATION_NAME = 'KnowledgeDiscoveryZeroQueries';

export const ZeroQueriesQuery = `
	query ${ZERO_QUERIES_OPERATION_NAME}($cloudId: String!) {
		knowledgeDiscovery @optIn(to: "KnowledgeDiscovery Get Zero Queries") {
			zeroQueries(cloudId: $cloudId) {
                __typename
                ... on KnowledgeDiscoveryZeroQueries {        
                    zeroQueries
                }
            }
		}
	}
`;
